import { createContext, useContext, useState, useEffect, useCallback } from "react";

export const THEMES = ["salvia", "cipria", "acqua"];
export const LOGO_IDS = ["foglia", "intersezione", "germoglio", "monogramma"];

const ThemeContext = createContext();

const read = (key, allowed, fallback) => {
  const saved = localStorage.getItem(key);
  return allowed.includes(saved) ? saved : fallback;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(() => read("gyc-theme", THEMES, "salvia"));
  const [logo, setLogoState] = useState(() => read("gyc-logo", LOGO_IDS, "intersezione"));

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  const setTheme = useCallback((t) => {
    setThemeState(t);
    localStorage.setItem("gyc-theme", t);
  }, []);

  const setLogo = useCallback((l) => {
    setLogoState(l);
    localStorage.setItem("gyc-logo", l);
  }, []);

  return <ThemeContext.Provider value={{ theme, setTheme, logo, setLogo }}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);
